import { getClientId, getConfig } from "./config";

const ALPHABET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

function base64UrlEncode(str: string) {
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function map<T, R>(a: ArrayLike<T>, transform: (v: T) => R): R[] {
  return Array.prototype.map.call(a, transform) as R[];
}

function oidcCompliantRandomString(length = 45) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  const chars = map(bytes, x => ALPHABET.charAt(x % ALPHABET.length));
  return chars.join("");
}

const ENCODER = new TextEncoder();

async function createChallenge() {
  const verifier = oidcCompliantRandomString();
  const verifierRaw = ENCODER.encode(verifier);
  const challengeRaw = new Uint8Array(
    await crypto.subtle.digest("SHA-256", verifierRaw),
  );
  const challenge = base64UrlEncode(
    String.fromCharCode.apply(null, challengeRaw as unknown as number[]),
  );
  return [challenge, verifier] as const;
}

async function createAndNoteChallenge() {
  const [challenge, verifier] = await createChallenge();
  window.sessionStorage.setItem("OIDC_Login_Challenge_PKCE_verifier", verifier);
  return challenge;
}

export async function createLoginUrl(configEndpoint?: string) {
  const [challenge, config] = await Promise.all([
    createAndNoteChallenge(),
    getConfig(configEndpoint),
  ]);

  const url = new URL(config.authorization_endpoint, window.location.href);
  url.searchParams.append("response_type", "code");
  url.searchParams.append("client_id", getClientId());
  url.searchParams.append(
    "state",
    window.location.pathname + window.location.search + window.location.hash,
  );
  url.searchParams.append(
    "redirect_uri",
    window.origin + "/portal-services/return-from-oidc",
  );
  url.searchParams.append("scope", "openid offline_access order");
  url.searchParams.append("code_challenge", challenge);
  url.searchParams.append("code_challenge_method", "S256");

  return url.toString();
}
